import React from 'react';

const VXFooter = () => (
	<div>
	</div>
);

export default VXFooter;



// WEBPACK FOOTER //
// ./src/VXFooter.js